import cn from 'classnames';
import { FC, useCallback, useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { ConsultationFragment } from '@/shared/api/transcriptor/transcriptorApi';

import styles from './TranscriptView.module.scss';
import { TranscriptFragment } from './ui/TranscriptFragment';

type TranscriptViewProps = {
  fragments: ConsultationFragment[];
  className?: string;
};

export const TranscriptView: FC<TranscriptViewProps> = (props) => {
  const { fragments, className } = props;

  const audioRefs = useRef<Record<string, HTMLAudioElement | null>>({});

  const handleChunkClick = useCallback((fragmentId: string, start: number) => {
    const audio = audioRefs.current[fragmentId];
    if (!audio) {
      return;
    }
    audio.currentTime = start;
    void audio.play().catch(() => {
      // Autoplay may be blocked; user can hit play manually.
    });
  }, []);

  if (fragments.length === 0) {
    return (
      <div className={cn(styles.empty, className)}>
        <FormattedMessage
          id="encounters.details.transcriptEmpty"
          defaultMessage="No audio available"
        />
      </div>
    );
  }

  return (
    <div
      className={cn(styles.container, className)}
      data-component="encounter-transcript"
    >
      {fragments.map((fragment, index) => (
        <TranscriptFragment
          key={fragment.id}
          audioRefs={audioRefs}
          fragment={fragment}
          index={index}
          onChunkClick={handleChunkClick}
        />
      ))}
    </div>
  );
};
